import gql from "graphql-tag";

export const READ = gql`
  query getProductSeo($id: Int!) {
    product(id: $id) {
      id
      seo {
        title
        meta_description
        og_image {
          id
          url
        }
      }
    }
  }
`;

export const UPSERT = gql`
  mutation upsertProductSeo($id: Int!, $input: SeoInput!) {
    upsertProductSeo(id: $id, input: $input) {
      seo {
        title
        meta_description
        og_image {
          id
          url
        }
      }
    }
  }
`;
